export const MAX_PAGE_SIZE = 20

// Size-based breakpoints for UiConfig - automatically generates named queries
// like isSmallPhone, isPhone, isTabletUp, isDesktopUp for use with useDeviceType()
export const ET_EDITOR_BREAKPOINTS = {
  small: 500,
  medium: 800,
  large: 1100,
  xLarge: 1500
}

export const scopes = [
  'all_users_and_teams',
  'all_users',
  'team',
  'user_group/:id',
  'user/:id',
  'team/:id',
  'user/me',
]

const paths = [
  '/event_types',
  '/app/scheduling/meeting_types'
]

export const etSidebarPaths = paths.flatMap((path) => scopes.map((scope) => ([path, scope].join('/'))))

export const metSidebarPaths = [
  '/app/admin/managed_event_types',
  '/app/admin/managed_event_types/new'
]
